import type { StackProps } from '@mui/material';
import { Stack, styled } from '@mui/material';

/**
 * 스크롤 처리를 위한 컨테이너.
 *
 * @see https://github.com/mui/material-ui/issues/13253#issuecomment-512208440
 */
export default styled(Stack)<StackProps>({
  overflowY: 'auto',
});
